module.exports = "/assets/data/04abb9e6ebf1a4effd026645b1d69468-B33.data.json";